// /src/constants/auth.js
export const API_BASE_URL = "/home-api";
export const PRE_LOGIN_UUID = "cekstyDVMuqXcjnYzbgLfhvc/OinFdxVZAVXF65bGsvq3SfhskkviH7tD/j3LJ9P";
export const POST_LOGIN_UUID = "i0reG0mDd31Y8WuJ28C3l47o2fWwIVL4E81M2AJe5aKvwBxtmNKQggp318x72Hyc";
